var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMigrationIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.394,
    height: 140.5,
    viewBox: "0 0 155.394 140.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.282,
    y1: 0.147,
    x2: 0.839,
    y2: 1.048,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5",
    stopOpacity: 0.49
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759",
    transform: "translate(-862.982 -236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M79.108,18a12,12,0,0,1,20.784,0L165.75,132.5a12,12,0,0,1-10.392,18H24a12,12,0,0,1-10.392-18Z",
    transform: "translate(851 218)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M70.562,12.086a8,8,0,0,1,13.876,0l63.683,110.931A8,8,0,0,1,141.183,135H13.817a8,8,0,0,1-6.938-11.983Z",
    transform: "translate(863 228)",
    fill: "#feb006"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M-493.88,1030.708h-15.525v-3.573h-16.585c.123.108.211.185.3.261q2.034,1.74,4.07,3.478c.126.107.132.183.021.311q-1.076,1.242-2.137,2.5c-.118.14-.185.165-.337.032q-1.71-1.49-3.436-2.962-3.145-2.7-6.3-5.388c-.131-.112-.118-.166,0-.268.5-.43,1-.867,1.5-1.3q2.243-1.965,4.485-3.931,1.842-1.611,3.689-3.217c.222-.194.238-.194.438.041q.976,1.149,1.956,2.294a.421.421,0,0,1-.046.594c-1.47,1.259-2.942,2.517-4.468,3.821h16.842v-9.761a3.837,3.837,0,0,0-3.837-3.837h-25.048a3.837,3.837,0,0,0-3.837,3.837v25.048a3.837,3.837,0,0,0,3.837,3.837h15.525v3.566H-506.1c-1.525-1.3-3-2.561-4.467-3.82a.422.422,0,0,1-.046-.594q.981-1.145,1.956-2.294c.2-.234.216-.234.438-.041q1.843,1.61,3.689,3.217,2.245,1.963,4.485,3.931c.5.437,1,.874,1.5,1.3.12.1.134.156,0,.268q-3.152,2.689-6.3,5.388-1.722,1.477-3.436,2.962c-.152.133-.219.108-.337-.032q-1.06-1.256-2.137-2.5c-.111-.128-.1-.2.021-.311q2.038-1.736,4.07-3.478c.089-.076.177-.154.3-.261h-16.4v9.768a3.837,3.837,0,0,0,3.837,3.837h25.048a3.837,3.837,0,0,0,3.837-3.837v-25.048A3.837,3.837,0,0,0-493.88,1030.708Z",
    transform: "translate(1459.085 -718.444)",
    fill: "#8b6002"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrationIc);
export default __webpack_public_path__ + "static/media/migration-ic.ead57b577afad15d0dedc7114a4db64c.svg";
export { ForwardRef as ReactComponent };